<template>
  <div class="bk-item-box">
    <img
      class="bk-item-cover"
      :src="
        cover
          ? $global.imgUrl + cover
          : require('@/assets/img/mobile-img/image_error_ic.webp')
      "
      alt=""
    />
    <p class="bk-item-name" v-html="name"></p>
  </div>
</template>

<script>
export default {
  // 封面 名字
  props: ["cover", "name"],
  data() {
    return {
      searchStr: "",
    };
  },
  computed: {
    // highLightName() {
    //   return this.name.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },
  },
  created() {
    // this.searchStr = this.$route.query.paramStr;
  },
};
</script>

<style scoped lang="scss">
.bk-item-box {
  width: 100px;
  .bk-item-cover {
    width: 100%;
    height: 140px;
    border-radius: 5px;
    overflow: hidden;
  }
  .bk-item-name {
    margin-top: 8px;
    font-size: 14px;
    color: #000;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>